import React from "react";
import ReactSelect from "react-select";
import { ErrorMessage } from "formik";

export default function CommonIndustryOption({
    options,
    formik,
    prop,
    setSelectedIndustry,
    setSelectCategory,
}) {
    return (
        <div className="form-group">
            <label>{prop.title}</label>
            <ReactSelect
                options={
                    Array.isArray(options)
                        ? options.map((lang) => ({
                            value: lang.id,
                            label: lang.title,
                        }))
                        : []
                }
                placeholder={prop.placeholder}
                value={
                    formik.values.industry_id
                        ? Array.isArray(options) &&
                            options.find((x) => x.id == formik.values.industry_id)
                            ? {
                                value: formik.values.industry_id,
                                label: Array.isArray(options) &&
                                    options.find((x) => x.id == formik.values.industry_id)?.title,
                            }
                            : null
                        : null
                }
                onChange={(option) => {
                    setSelectCategory(null);
                    setSelectedIndustry(option?.value);
                    formik.setFieldValue("industry_id", option?.value || "");
                    formik.setFieldValue("industry_index", option || "");
                    formik.setFieldValue("category_id", "");
                    formik.setFieldValue("sub_category_id", "");
                    formik.setFieldValue("subcategory_index", "");
                    formik.setFieldValue("sub_category_title", "");
                }}
            />
            <ErrorMessage name={prop.name} component="div" className="error" />
        </div>
    );
}
